import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useArrayFieldApi } from 'informed';
import { Button } from '@tesla/design-system-react';

var _excluded = ["text"];
var AddButton = function AddButton(props) {
  var _useArrayFieldApi = useArrayFieldApi(),
    add = _useArrayFieldApi.add;
  var text = props.text,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    type: "button",
    onClick: add
  }, rest), text !== null && text !== void 0 ? text : 'Add');
};

export { AddButton };
